import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Munkavégzés 24–48 órán belül",
  "Számlaképes szolgáltatás",
  "Környezetbarát hulladékkezelés",
  "Hétvégén is dolgozunk",
  "Rejtett költségek nélkül",
  "Ingyenes árajánlat fotó alapján",
];

export default function TrustMarquee() {
  return (
    <div data-testid="trust-marquee" className="bg-[#1E293B] py-5 overflow-hidden">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center gap-6 mx-6">
            <span className="font-display font-bold text-white/90 text-lg tracking-tight whitespace-nowrap">
              {item}
            </span>
            <Sparkle className="w-4 h-4 text-[#16A34A] shrink-0" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
